import axiosInstance from './AxiosInstance';
import { store } from '../store/store';

export function getItems() {
    return axiosInstance.get(`vendor/restaurants/show?id=1`);
}


export function createItem(item) {
    console.log(item);
    const state = store.getState();
    item.created_by = state.auth.auth.user.id;
    // const formData = new FormData();
    // formData.append("name", item.name);
    // formData.append("image", item.image);
    // formData.append("status", item.name);
    // formData.append("created_by", state.auth.auth.user.id);
    const postData = {
        ...item
    };
    return axiosInstance.post("admin/items", postData,);
}


export function updateItem(item,id) {
    const state = store.getState();
    item.created_by = state.auth.auth.user.id;
    // const formData = new FormData();
    // formData.append("name", item.name);
    // formData.append("image", item.image);
    // formData.append("status", item.name);
    // formData.append("created_by", state.auth.auth.user.id);
    const postData = {
        ...item
    };
    return axiosInstance.put("admin/items?id="+id, postData,);
}

export function getSelectedItem(id) {
    return axiosInstance.get(`admin/items/show?id=`+id);
}
export function changeStatusItem(item,id) {
    console.log(item);
    const state = store.getState();
    item.created_by = state.auth.auth.user.id;
    // const formData = new FormData();
    // formData.append("name", item.name);
    // formData.append("image", item.image);
    // formData.append("status", item.name);
    // formData.append("created_by", state.auth.auth.user.id);
    const postData = {
        ...item
    };
    return axiosInstance.put("admin/items/status?id="+id, postData,);
}
export function deleteItem(id) {
    return axiosInstance.delete(`admin/items?id=`+id);
}